import React from "react";
import { Spin } from "antd";

export default function PageLoading() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexGrow: 1,
        height: "80vh",
      }}
    >
      <Spin />
    </div>
  );
}
